import dayjs from 'dayjs';

const DEFAULT_TIME = 36000; // 10:00 AM in seconds
const TIME_INCREMENT = 1800; // 30 minutes in seconds
const END_OF_DAY = 86400; // 24:00 in seconds (exclusive)

export const adjustTimesForSelection = (
  from: Date | undefined,
  to: Date | undefined,
  fromTime: number = DEFAULT_TIME,
  toTime: number = DEFAULT_TIME,
): { from_time: number; to_time: number; to?: Date } => {
  const isSameDay = from && to && dayjs(from).isSame(to, 'day');

  // If same day and have times, but to time is before or equal to from time, adjust it.
  if (isSameDay && toTime <= fromTime) {
    const adjustedToTime = fromTime + TIME_INCREMENT;

    // If adjusted to time goes past end of day, update the to date to the next day.
    return adjustedToTime >= END_OF_DAY
      ? { from_time: fromTime, to_time: 0, to: dayjs(from).add(1, 'day').toDate() }
      : { from_time: fromTime, to_time: adjustedToTime };
  }

  return {
    from_time: fromTime,
    to_time: toTime,
  };
};
